import request from '@/utils/request'

export function updateLimitCfg(data) {
  return request({
    url: 'api/v1/limit/updateLimitCfg',
    method: 'post',
    data: data
  })
}

export function getLimitCfgList(data) {
  return request({
    url: 'api/v1/limit/getLimitCfg',
    method: 'post',
    data: data
  })
}
